import React, { useState,useEffect } from "react";
import EmployeeNavbar from "./EmployeeNavbar";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import ReactPaginate from "react-paginate";
function AllJobsEmployeePage() {
    const ID = Cookies.get("log_id");
    const [jobs,setJobs] = useState([]);
    function Fetch_All_Jobs_Employee() {
        axios.get(`${url.path}/fetch_all_jobs_employee/${ID}/`)
        .then((res) =>{
            if(res.data.status){
                var job = res.data.jobs;
                setJobs([])
                job.map((r)=>{
                    setJobs((prevState)=>[
                        ...prevState, r
                    ])
                })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(() =>{
        Fetch_All_Jobs_Employee();
    }, [])
    const itemsPerPage = 3;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);

    const filteredData = jobs.filter((item) =>
      item.Job_Name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const offset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageClick = ({ selected }) => {
      setCurrentPage(selected);
    };
    function searchTable(){
      var rows = document.querySelectorAll('#productstable tbody tr');
      var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
      rows.forEach(function(row) {
        var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
        row.style.display = text.includes(val) ? '' : 'none';
      });
    }
    return(
        <>
        <EmployeeNavbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>All Jobs</h3>
            </center>
            <div className="search-container">
                <input
                type="text"
                placeholder="Search..."
                onKeyUp={searchTable}
                className="search-input"
                id="search"
                />
            </div>
        <div className="table-container">
            
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Job Name</th>
            <th>Description</th>
            <th>Skills</th>
            <th>Last Date</th>
            <th>Expected Date</th>
            <th>More</th>
          </tr>
        </thead>
        <tbody>
          {jobs.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Job_Name}</td>
              <td>{i.Description}</td>
              <td>{i.Skills}</td>
              <td>{i.Last_Date_Apply}</td>
              <td>{i.Expected_Join}</td>
              <td><button style={{width:'50px',borderRadius:'5px',backgroundColor:'grey',color:'white'}}>View</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default AllJobsEmployeePage;